<template>
    <block-sidebar
        title="Esporta"
        v-if="!!exports && !!Object.keys(exports).length"
    >
        <template v-slot:icon>
            <font-awesome-icon
                :icon="['fad', 'file-export']"
            ></font-awesome-icon>
        </template>

        <btn
            type="secondary"
            block
            title="PDF"
            :action="exportPDF"
            v-if="!!exports.pdf"
        ></btn>
        <btn
            type="secondary"
            block
            title="Excel"
            :action="exportExcel"
            v-if="!!exports.excel"
        ></btn>
    </block-sidebar>
</template>

<script>
export default {
    data: () => ({
        exports: null
    }),
    props: {
        refTable: {
            type: String,
            default: "",
            required: true
        }
    },
    mounted: function() {
        if (typeof this.getTable !== "undefined")
            this.exports = this.getTable.exports;
    },
    computed: {
        getTable: function() {
            return this.$root.$refs[this.refTable];
        }
    },
    methods: {
        exportPDF: function() {
            this.getTable.showLoader();

            let body = this.getTable.exportParams();
            if (!body) return this.getTable.hideLoader();

            this.$root.request(
                this,
                this.exports.pdf,
                "POST",
                body,
                response => {
                    if (response instanceof Object == false)
                        return this.getTable.hideLoader();

                    if (typeof response.data === "string")
                        window.open(response.data, "_blank");
                    this.getTable.hideLoader();
                },
                ({ response, message }) => {
                    this.getTable.hideLoader();
                }
            );
        },
        exportExcel: function() {
            this.getTable.showLoader();

            let body = this.getTable.exportParams();
            if (!body) return this.getTable.hideLoader();

            this.$root.request(
                this,
                this.exports.excel,
                "POST",
                body,
                response => {
                    if (response instanceof Object == false)
                        return this.getTable.hideLoader();

                    if (typeof response.data === "string")
                        window.open(response.data, "_blank");
                    this.getTable.hideLoader();
                },
                ({ response, message }) => {
                    this.getTable.hideLoader();
                }
            );
        }
    }
};
</script>
